import React from 'react'

import * as S from './toggle-switch.styled'

export interface ToggleSwitchProps extends React.InputHTMLAttributes<HTMLInputElement> {
  checked: boolean
  falsyLabel: string
  truthyLabel: string
}

export const ToggleSwitch = ({ checked, falsyLabel, truthyLabel, ...rest }: ToggleSwitchProps) => {
  return (
    <S.SwitchWrapper data-checked={checked} data-component-id="ToggleSwitch">
      <S.HiddenInput {...rest} type="checkbox" checked={checked} />
      <S.SwitchLabel data-active={!checked} data-type="falsy">
        {falsyLabel}
      </S.SwitchLabel>
      <S.SwitchLabel data-active={checked} data-type="truthy">
        {truthyLabel}
      </S.SwitchLabel>
    </S.SwitchWrapper>
  )
}
